/* jshint esversion: 6 */
/* jshint ignore:start */
import React, { useContext, useEffect, useRef, useState } from 'react';
import WalletLottie from "../Lottie/wallet.json";
import Lottie from "lottie-react";
import { MyContext } from '../../Context/MyProvider';
import axios from 'axios';
import { FaWallet } from 'react-icons/fa';
import { showToast } from '../../showTost';
import { LuWallet } from "react-icons/lu";
import Razorpay from '../../Payment/RazorPay';
import PayPal from '../../Payment/PayPal';
import { useTranslation } from 'react-i18next';
import Loading from '../Loading';
import secureLocalStorage from "react-secure-storage";
import Stripe from '../../Payment/Stripe';
import Paystack from '../../Payment/Paystack';
import Flutterwave from '../../Payment/Flutterwave';
import SenangPay from '../../Payment/SenangPay';
import PayFast from '../../Payment/PayFast';
import Midtrans from '../../Payment/Midtrans';
const Wallet = () => {

  const { t } = useTranslation();
  const { ApiBaseUrl, ImgBaseUrl, paymentStatus, setPaymentStatus, apiloading } = useContext(MyContext);

  const [mywallet, setMyWallet] = useState();
  const [history, setHistory] = useState([]);
  const [isShow, setIsShow] = useState(false);
  const [isPaymentShow, setIsPaymentShow] = useState(false);
  const [paymentList, setPaymentList] = useState([]);
  const [selectPaymentId, setSelectPaymentId] = useState();
  const [attribute, setAttribute] = useState("");
  const [input, setInput] = useState();
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(1);
  const [totallength, setTotalLength] = useState(0);

  const hasReachedBottom = useRef(false);
  const NoMoreDataRef = useRef(true);
  const PaymentRef = useRef(false);

  const site_currency = secureLocalStorage.getItem("currency");
  const currency = site_currency ? site_currency : "$";
  const Userid = secureLocalStorage.getItem("Userid");

  useEffect(() => {
    HandlefetchData(1);
    HandleGetPaymentList();
  }, []);

  const HandlefetchData = (page) => {
    if (Userid) {
      axios.post(`${ApiBaseUrl}/customer/wallet_transaction_list`, { id: Userid, page })
        .then((res) => {
          // console.log("wallet_transaction_list", res);
          if (res.data.ResponseCode === 200) {

            const { tot_balance, wallet_list } = res.data;

            if (wallet_list.length === 0 || totallength > wallet_list.length) {
              NoMoreDataRef.current = false;
            }

            if (page === 1) {
              setHistory(wallet_list);
              setTotalLength(tot_balance.length);
            } else {
              setHistory(prev => [...prev, ...wallet_list]);
            }

            setLoading(false);
            setMyWallet(tot_balance);
          }
        })
        .catch((error) => {
          console.error(error);
        });
    }
  };

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
      const scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight;
      const clientHeight = window.innerHeight;

      const isAtBottom = scrollTop + clientHeight >= scrollHeight - 100;

      if (isAtBottom && !hasReachedBottom.current && NoMoreDataRef.current) {
        hasReachedBottom.current = true;
        setPage(prevPage => prevPage + 1);
      } else if (!isAtBottom && hasReachedBottom.current) {
        hasReachedBottom.current = false;
      }
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };

  }, []);

  useEffect(() => {
    if (page === 1 || !NoMoreDataRef.current) return;
    HandlefetchData(page);
  }, [page])

  const HandleGetPaymentList = () => {
    if (Userid) {
      axios.get(`${ApiBaseUrl}/customer/wallet_payment_list`)
        .then((res) => {
          // console.log("wallet_payment_list", res);
          setPaymentList(res.data.payment_list);
        })
        .catch((error) => {
          console.error(error);
        });
    }
  };

  const SelectPayment = (item) => {
    setSelectPaymentId(item.id);
    setAttribute(item.attribute);
  };

  const HandleContinue = () => {

    if (!input) {
      showToast({ title: t("Please Enter Amount"), id: "error" });
      return;
    }

    if (!selectPaymentId) {
      showToast({ title: t("Select Payment Method"), id: "error" });
      return;
    }

    sessionStorage.setItem("Paymentid", selectPaymentId);
    secureLocalStorage.setItem("walletamt", input);
    PaymentRef.current = false;
    setIsPaymentShow(true);
  };

  useEffect(() => {
    if (!paymentStatus) return;
    if (paymentStatus === "PaymentDone") {
      HandlePaymeDone();
      setPaymentStatus("");
      setIsPaymentShow(false);
    } else {
      setPaymentStatus("");
      setIsPaymentShow(false);
      setIsShow(false);
      setSelectPaymentId("");
    }
  }, [paymentStatus]);

  const HandlePaymeDone = () => {

    if (PaymentRef.current) return;

    PaymentRef.current = true;

    const PaymentId = sessionStorage.getItem("Paymentid");
    const amount = secureLocalStorage.getItem("walletamt");

    axios.post(`${ApiBaseUrl}/customer/add_wallet`, { id: Userid, amount, payment_type: PaymentId || selectPaymentId })
      .then((res) => {
        // console.log(res);
        if (res.data.ResponseCode) {
          HandlefetchData(1);
          setIsShow(false);
          showToast({ title: res.data.message, id: "success" });
          sessionStorage.removeItem("Paymentid");
          secureLocalStorage.removeItem("walletamt")
        }
      })
      .catch((error) => {
        console.error(error);
      });
  };

  return (
    <div>
      {loading
        ? <Loading CustomeStyle="h-[100vh] -mt-[140px] w-full flex items-center justify-center bg-white" index={0} />
        : <div className="">

          <div className="d-flex flex-wrap justify-between border-[2px] border-[#8080803b] px-[40px] py-[15px] rounded-[20px]">
            <div className="d-flex gap-[20px]">
              <Lottie
                className="w-[60px]"
                animationData={WalletLottie}
                loop={true}
              />
              <div className="">
                <span className='text-gray-500 font-[500] text-[16px]'>{t("TOTAL WALLET BALANCE")}</span>
                <h1 className='font-[500] text-[18px]'>{currency ? currency : "$"} {mywallet}</h1>
              </div>
            </div>
            <button onClick={() => setIsShow(true)} className='bg-[#0d4047] text-white font-[500] min-w-[150px] py-[8px] rounded-[50px]'>{t("Top Up")}</button>
          </div>

          <div className="mt-[15px]">
            <h1 className='font-[500] text-[18px]'>{t("Transaction History")}</h1>
            {history.length >= 1
              ? history.map((item, index) => {
                const Credit = item.status === "1" || item.status === "3" || item.status === "5" || item.status === "7";
                return <div key={index} className="border-[1px] border-[#8080803b] px-[20px] py-[15px] rounded-[15px] mt-[5px]">
                  <div className="flex items-center gap-[10px] justify-between">
                    <div className="flex items-center gap-[10px]">
                      <div className={`${Credit ? "bg-green-100" : "bg-red-100"} p-[10px] rounded-[100%]`}>
                        <FaWallet className={`${Credit ? "text-green-500" : "text-red-500"} text-[20px]`} />
                      </div>
                      <div className="leading-[20px]">
                        <h1 className='font-[500] text-[17px]'>{item.date}</h1>
                        <span className={`${Credit ? "text-green-500" : "text-red-500"} font-[500] text-[14px]`}>{Credit ? "Credit" : "Debit"}</span>
                      </div>
                    </div>
                    <h1 className={`${Credit ? "text-green-500" : "text-red-500"} font-[500] text-[17px]`}>{Credit ? "+" : "-"} {currency}{item.amount}.0</h1>
                  </div>
                </div>
              })
              : <div className='h-[400px] flex items-center justify-center'>
                <h1 className='font-[500] text-gray-500 text-[18px]'>{t("Go & Add your Amount")}</h1>
              </div>}
          </div>
        </div>}

      {isShow && <div onClick={() => setIsShow(false)} className="flex bg-[#00000069] h-full justify-center w-full fixed items-end left-0 top-0 z-[999]">
        <div style={{ borderRadius: "10px 10px 0 0" }} onClick={(e) => e.stopPropagation()} className="bottme-box">
          <h1 className='font-[500] text-[17px] text-[#0d4047]'>{("Add Wallet Amount")}</h1>
          <div className="flex items-center gap-[5px] focus-within:border-[#0d4047] mt-[5px] border-[2px] border-[#8080803b] py-[8px] px-[15px] rounded-[10px]">
            <LuWallet className='text-[23px] text-gray-500' />
            <input onChange={(e) => setInput(e.target.value)} type="number" placeholder={t('Enter Amount')} className='w-[100%] bg-transparent outline-none px-[10px] font-[500]' />
          </div>
          <h1 className='mt-[5px] font-[500] text-gray-500'>{t("Select Payment Method")}</h1>
          <div className="h-[400px] scroll-container">
            {paymentList.length >= 1
              ? paymentList.map((item, index) => {
                return <div onClick={() => SelectPayment(item)} key={index} className={`payment-box border-[1px] ${selectPaymentId === item.id ? "border-[#0d4047]" : "border-[#8080803b]"}`}>
                  <div className="flex items-center gap-[10px]">
                    <img className="w-[60px] border-[1px] border-gray-300 rounded-[10px]" alt="Payment Img" src={ImgBaseUrl + item.image} />
                    <div className="">
                      <h1 className='font-[500] text-[17px]'>{item.name}</h1>
                      <p className='font-[500] text-[15px] leading-[18px] text-gray-800'>{item.sub_title}</p>
                    </div>
                  </div>
                  <div className="w-[30px] check-box">
                    <input id="radio1" className="peer hidden" type="radio" name="group1" />
                    <div className={`w-5 h-5 rounded-full flex items-center justify-center ${selectPaymentId === item.id ? "box-activeborder" : "box-border"}`}>
                      <span className={`w-[10px] h-[10px] rounded-full duration-[0.3s] ${selectPaymentId === item.id && "box-activebg"}`}></span>
                    </div>
                  </div>
                </div>
              })
              : <div className='h-[100%] flex items-center justify-center'>
                <h1 className='font-[500] text-[18px]'>{t("Loading...")}</h1>
              </div>}
          </div>
          <button onClick={HandleContinue} className='payment-btn mt-[5px]'>
            {apiloading
              ? <div className="loader mx-auto"></div>
              : <span>{t("Continue")}</span>}
          </button>
        </div>
      </div>}

      {(selectPaymentId === 1 && isPaymentShow) && <Razorpay Amount={input} Attribute={attribute} />}
      {(selectPaymentId === 2 && isPaymentShow) && <PayPal Amount={input} />}
      {(selectPaymentId === 3 && isPaymentShow) && <Stripe Amount={input} />}
      {(selectPaymentId === 4 && isPaymentShow) && <Paystack Amount={input} />}
      {(selectPaymentId === 5 && isPaymentShow) && <Flutterwave Amount={input} />}
      {(selectPaymentId === 7 && isPaymentShow) && <SenangPay Amount={input} />}
      {(selectPaymentId === 9 && isPaymentShow) && <PayFast Amount={input} />}
      {(selectPaymentId === 10 && isPaymentShow) && <Midtrans Amount={input} />}

    </div>
  )
}

export default Wallet
/* jshint ignore:end */